import { render, staticRenderFns } from "./DettaglioField.vue?vue&type=template&id=48209f00&"
import script from "./DettaglioField.vue?vue&type=script&lang=js&"
export * from "./DettaglioField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports